import { render } from "./Completed.vue?vue&type=template&id=60afff7f"
import script from "./Completed.vue?vue&type=script&lang=js"
export * from "./Completed.vue?vue&type=script&lang=js"

import "./Completed.vue?vue&type=style&index=0&id=60afff7f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__